import { render } from "./WavesList.vue?vue&type=template&id=42b6e3ca"
import script from "./WavesList.vue?vue&type=script&lang=js"
export * from "./WavesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__